import React from "react";
import { Flex, Text, LoadingIndicator } from "@jsq/ds/core";
import {
  pageContainer,
  headerContainer,
  contentArea,
  placeholderContainer,
} from "./styles_vanilla.css";
import { FundDetailsProps } from "./types";

export const FundDetails: React.FC<FundDetailsProps> = ({ fund }) => {
  if (!fund) {
    return (
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        className={pageContainer}
      >
        <LoadingIndicator />
      </Flex>
    );
  }

  return (
    <Flex className={pageContainer} flexDirection="column">
      <Flex className={headerContainer} flexDirection="column" gap={8}>
        <Text variant="strong-xl">{fund.name}</Text>
        <Text variant="regular-md" color="muted">
          {fund.arenaName}
        </Text>
      </Flex>
      <Flex className={contentArea} flexDirection="column">
        <Flex className={placeholderContainer} flexDirection="column" gap={16}>
          <Text variant="strong-lg">Fund Details</Text>
          <Text variant="regular-md" color="muted">
            Detailed fund information will be displayed here in a future update.
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default FundDetails;
